import { Button } from '@/components/ui/button'
import { CheckCircle } from 'lucide-react'
import { useIntersectionObserver } from '@/hooks/use-intersection-observer'
import { cn } from '@/lib/utils'
import { useNavigate } from 'react-router-dom'

export function ForEducators() {
  const { elementRef, isVisible } = useIntersectionObserver()
  const navigate = useNavigate()

  return (
    <section
      ref={elementRef}
      id="educadores"
      className="py-24 bg-gradient-to-br from-blue-50 to-indigo-50"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-16 rounded-3xl bg-white p-8 md:p-12 shadow-xl border border-blue-100">
          <div
            className={cn(
              'flex-1 space-y-8',
              isVisible ? 'animate-slide-up' : 'opacity-0',
            )}
          >
            <div className="inline-block px-4 py-1.5 rounded-full bg-brand-blue/10 text-brand-blue font-semibold text-sm">
              Para Professores, Coordenadores e Diretores
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy">
              Sua próxima grande oportunidade está aqui
            </h2>

            <p className="text-lg text-slate-600">
              Não somos apenas um banco de currículos. Somos a ponte direta para
              as melhores escolas da sua região. Valorize sua carreira.
            </p>

            <ul className="space-y-4">
              {[
                'Cadastro 100% gratuito para educadores',
                'Vagas reais em escolas verificadas',
                'Contato direto com quem contrata',
                'Visibilidade para centenas de escolas',
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-brand-blue flex-shrink-0" />
                  <span className="text-slate-700 font-medium">{item}</span>
                </li>
              ))}
            </ul>

            <div className="pt-4">
              <Button
                size="lg"
                className="bg-brand-blue hover:bg-blue-700 text-white font-bold h-12 px-8 shadow-lg shadow-blue-200"
                onClick={() => navigate('/cadastro-educador')}
              >
                👉 Criar perfil gratuitamente
              </Button>
            </div>
          </div>

          <div
            className={cn(
              'flex-1 w-full max-w-md lg:max-w-full',
              isVisible ? 'animate-fade-in' : 'opacity-0',
            )}
          >
            <div className="relative aspect-square md:aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl rotate-3 hover:rotate-0 transition-all duration-500">
              <img
                src="https://img.usecurling.com/p/600/600?q=teacher%20smiling%20classroom"
                alt="Professora sorrindo na sala de aula"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-blue/80 to-transparent flex items-end p-8">
                <div className="text-white">
                  <p className="font-bold text-2xl">Carreira em Foco</p>
                  <p className="opacity-90">
                    Junte-se a milhares de educadores.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
